var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.7 426.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M192 192h42.7v128H192V192z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M213.3 0C95.5 0 0 95.5 0 213.3s95.5 213.3 213.3 213.3 213.3-95.5 213.3-213.3S331.2 0 213.3 0zm0 384c-94.1 0-170.7-76.6-170.7-170.7S119.3 42.7 213.3 42.7 384 119.3 384 213.3 307.4 384 213.3 384z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M192 106.7h42.7v42.7H192v-42.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDark);
export default __webpack_public_path__ + "static/media/infoDark.af2be6f6ba2c2a555ce17db60a1ce9fe.svg";
export { ForwardRef as ReactComponent };